import type {
  EventCategory,
  EventCategoryCreateInput,
  EventCategoryListResponse,
  EventCategoryUpdateInput,
} from "@cdt/shared";

import { api } from "@/lib/api";

export async function fetchCategories(): Promise<EventCategoryListResponse> {
  return api.get<EventCategoryListResponse>("/api/categories");
}

export async function createCategory(
  payload: EventCategoryCreateInput,
): Promise<EventCategory> {
  return api.post<EventCategory>("/api/categories", payload);
}

export async function updateCategory(
  id: string,
  payload: EventCategoryUpdateInput,
): Promise<EventCategory> {
  return api.patch<EventCategory>(`/api/categories/${encodeURIComponent(id)}`, payload);
}

export async function deleteCategory(
  id: string,
  force = false,
  reassignToId?: string,
): Promise<void> {
  const params = new URLSearchParams();
  if (force) params.set("force", "true");
  if (reassignToId) params.set("reassignToId", reassignToId);
  const qs = params.toString();
  await api.delete<unknown>(
    `/api/categories/${encodeURIComponent(id)}${qs ? `?${qs}` : ""}`,
  );
}
